import { render, staticRenderFns } from "./ProfileUploadDocument.vue?vue&type=template&id=24f14836&scoped=true&"
import script from "./ProfileUploadDocument.vue?vue&type=script&lang=js&"
export * from "./ProfileUploadDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f14836",
  null
  
)

export default component.exports